import { Children, ComponentPropsWithoutRef } from 'react';

import { ChevronRightIcon } from '@sternum/ui';

import { SectionStyled } from './Section.styles';

export interface AppHeaderSectionProps extends ComponentPropsWithoutRef<'div'> {
  isArrowBetweenVisible?: boolean;
}

export function Section({ isArrowBetweenVisible = false, children, ...props }: AppHeaderSectionProps) {
  return (
    <SectionStyled role="presentation" aria-label="application header section" {...props}>
      {Children.map(Children.toArray(children), (child, index) => (
        <>
          {isArrowBetweenVisible && index !== 0 && <ChevronRightIcon />}
          {child}
        </>
      ))}
    </SectionStyled>
  );
}
